import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import Box from './Box';
import Code from './Code';
import Wrapper from './Wrapper';

function RotateDemo({ rotation, unit }) {
  const styles = useSpring({
    transform: `rotate(${rotation}${unit})`,
  });

  return (
    <Wrapper>
      <Box style={styles} />
      <Code>
        transform: rotate({rotation}
        {unit});
      </Code>
    </Wrapper>
  );
}

export default RotateDemo;
